var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.219795 9.96934C-0.0727023 10.2618 -0.0727023 10.7366 0.219795 11.0302C0.512293 11.3238 0.98704 11.3227 1.28066 11.0302L0.219795 9.96934ZM5.25076 5.99924L5.78063 6.52912C6.07312 6.23662 6.07312 5.76187 5.78063 5.46825L5.25076 5.99924ZM1.28066 0.96941C0.988165 0.676911 0.513418 0.676911 0.219795 0.96941C-0.0738274 1.26191 -0.0727023 1.73665 0.219795 2.03028L1.28066 0.96941ZM1.28066 11.0302L5.78063 6.52912L4.71976 5.46937L0.219795 9.96934L1.28066 11.0302ZM5.78063 5.46937L1.28066 0.96941L0.219795 2.03028L4.71976 6.53024L5.78063 5.46937Z",
    fill: "#485266"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.e450ceaf0be73901fbb9dfb18cac5bc9.svg";
export { ForwardRef as ReactComponent };